import {FC, useEffect} from 'react'

import cn from 'classnames/bind'

import FormInvoice from 'components/blocks/forms/FormInvoice'
import InvoiceCustomize from 'components/blocks/invoice/InvoiceCustomize/InvoiceCustomize'
import InvoiceFaq from 'components/blocks/invoice/InvoiceFaq/InvoiceFaq'
import InvoiceHow from 'components/blocks/invoice/InvoiceHow/InvoiceHow'
import InvoiceReasons from 'components/blocks/invoice/InvoiceReasons/InvoiceReasons'
import InvoiceTestimonials from 'components/blocks/invoice/InvoiceTestimonials/InvoiceTestimonials'
import InvoiceTypes from 'components/blocks/invoice/InvoiceTypes/InvoiceTypes'
import InvoiceUsers from 'components/blocks/invoice/InvoiceUsers/InvoiceUsers'
import InvoiceWhat from 'components/blocks/invoice/InvoiceWhat/InvoiceWhat'
import InvoiceWhy from 'components/blocks/invoice/InvoiceWhy/InvoiceWhy'
import LandingsTitle from 'components/blocks/LandingsTitle/LandingsTitle'
import {Col, Container, Row} from 'components/elements/grid'
import {IInvoiceContent} from 'pages/invoice-generator'
import {posthogTrack, klaviyoTrack} from 'src/utils'

import s from './TemplateCreateDocumentInvoice.module.scss'

const cx = cn.bind(s)

interface ITemplateCreateDocumentInvoiceProps {
	className?: string
	invoiceContent: IInvoiceContent
}

const TemplateCreateDocumentInvoice: FC<ITemplateCreateDocumentInvoiceProps> = ({
	className,
	invoiceContent,
}) => {
	useEffect(() => {
		posthogTrack('[FREE INVOICE] Create invoice page opened')
		klaviyoTrack('Page opened', {page: 'invoice', href: window?.location?.href})
	}, [])

	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<Row>
					<Col lg={{span: 10, offset: 1}} xl={{span: 8, offset: 2}}>
						<LandingsTitle
							type="top"
							className={s.title}
							topClassName={s.titleTop}
							title={invoiceContent.title}
							subtitle={invoiceContent.description}
						/>
					</Col>
				</Row>
			</Container>
			<Container>
				<FormInvoice />
			</Container>

			<InvoiceWhy className={cx('why')} content={invoiceContent.why} />
			<InvoiceWhat className={cx('section', 'what')} content={invoiceContent.what} />
			<InvoiceHow className={cx('section', 'how')} content={invoiceContent.how} />
			<InvoiceCustomize className={cx('section', 'customize')} content={invoiceContent.customize} />
			<InvoiceReasons className={cx('section', 'reasons')} content={invoiceContent.reasons} />
			<InvoiceUsers className={cx('section', 'users')} content={invoiceContent.users} />
			<InvoiceTestimonials
				className={cx('section', 'testimonials')}
				content={invoiceContent.testimonials}
			/>
			<InvoiceTypes className={cx('section', 'types')} content={invoiceContent.types} />
			<InvoiceFaq className={cx('section', 'faq')} content={invoiceContent.faq} />
		</div>
	)
}

TemplateCreateDocumentInvoice.displayName = 'TemplateCreateDocumentInvoice'

export default TemplateCreateDocumentInvoice
